<template>
  <div class="main-app">
    <el-container>
      <first-login-modal
        v-if="loginModalVisible && authenticated"
        :initial-visibility="loginModalVisible"
      />
      <access-keys-modal
        v-if="accessKeysVisible"
        :display="accessKeysVisible"
        @toggleDisplayAccessKeys="toggleDisplayAccessKeys"
      />
      <header-layout
        :authenticated="authenticated"
        @logout="logout"
        @toggleDisplayAccessKeys="toggleDisplayAccessKeys"
      />
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import HeaderLayout from './layouts/HeaderLayout';
import NavBar from './components/NavBar';
import FirstLoginModal from './components/FirstLoginModal';
import AccessKeysModal from './components/AccessKeysModal';
import { ROUTES } from './constants';
import { getAuthentication } from './utils';

export default {
  name: 'App',
  components: {
    HeaderLayout,
    NavBar,
    FirstLoginModal,
    AccessKeysModal,
  },
  data() {
    return {
      authenticated: false,
      loginModalVisible: false,
      accessKeysVisible: false,
    };
  },
  created() {
    this.validateUser();
  },
  watch: {
    $route: 'validateUser',
  },
  computed: {
    ...mapGetters('user', { user: 'getUser' }),
  },
  methods: {
    async validateUser() {
      // shows error in an alert for login problems
      if (this.$route.query.error) {
        const message = this.$route.query.error;
        this.$alert(message, {
          confirmButtonText: 'OK',
        });
      }

      const { isAuthenticated } = await getAuthentication(null, this);
      if (isAuthenticated) {
        this.loginModalVisible = this.user.isFirstLogged;
      }
      this.authenticated = isAuthenticated;
    },
    logout() {
      this.$auth0.logout();
      this.resetUser();
      this.$router.push(ROUTES.HOME);
    },
    toggleDisplayAccessKeys() {
      this.accessKeysVisible = !this.accessKeysVisible;
    },
    ...mapActions('user', { resetUser: 'resetUser' }),
  },
};
</script>

<style lang="scss">
@import 'scss/variables';
html,
body {
  color: #2c3e50;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  margin: 0;
  padding: 0;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.main-app {
  height: 100%;
}

.svg-diet-icon {
  width: $card-icon-size;
  height: $card-icon-size;
  vertical-align: middle;
  margin: 0 5px;
}

.el-main {
  top: 60px;
  position: absolute;
  width: 100%;
}
.el-container {
  position: relative;
  height: 100%;
}
.el-message {
  font-family: 'Avenir';
  font-size: 20px;
}
.el-message-box {
  &__message {
    p {
      font-family: 'Avenir';
      font-size: 16px;
      font-size: 16px;
      white-space: pre-line;
    }
  }
}
.el-button {
  &--small {
    span {
      font-family: 'Avenir';
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue